export default __webpack_public_path__ + "static/media/Darkblade's Belt of Secret Doors.e3b36d84.jpg";